<script setup>
import { ref } from 'vue'
import IconMinus from '../../../assets/svg/ico-minus.svg'
import IconPlus from '../../../assets/svg/ico-svg-plus.svg'

const props = defineProps({
	title: { type: String, required: true },
	ariaTitle: { type: String, required: true },
	isOpened: {
		type: Boolean,
		default: false,
		required: false,
	},
})

const showPanel = ref(props.isOpened)

function togglePanel() {
	showPanel.value = !showPanel.value
}
</script>

<template>
	<div class="panel">
		<div
			:id="`accordion-control-${ariaTitle}`"
			:arial-controls="`accordion-content-${ariaTitle}`"
			class="w-full flex flex-row items-center justify-between cursor-pointer py-5 gap-10 border-t group"
			@click.prevent="togglePanel"
		>
			<h3
				class="group-hover:text-idrive-dark transition-hover pb-0"
				:class="showPanel ? 'text-idrive-dark' : ''"
			>
				{{ title }}
			</h3>
			<div class="flex items-center justify-center relative right-2">
				<Transition name="fade">
					<IconMinus
						v-if="showPanel"
						key="collapse"
						class="absolute"
					/>
					<IconPlus v-else key="expand" class="absolute" />
				</Transition>
			</div>
		</div>
		<Transition name="fade">
			<div v-show="showPanel" class="pb-8 text-gray-700 leading-normal">
				<slot />
			</div>
		</Transition>
	</div>
</template>
